export default function getTotalSessionMs(sessions) {
	return sessions.reduce((total, session) => total + (session.end - session.start), 0) * 1000;
}
